"use client";

import { Container, Heading } from "@pamperedchef/design-system";

import { OfferReference } from "@/types";

import { OfferCardBlock } from "../offer-card/client";
import styles from "./offer-card-gallery.module.scss";

export interface OfferCardGalleryBlockProps {
	title?: string;
	cardsContent: OfferReference[];
}

/**
 * Offer Card Gallery block component
 */
export function OfferCardGalleryBlock(
	props: OfferCardGalleryBlockProps
): JSX.Element {
	return (
		<Container className={styles["offer-card-gallery"]}>
			{props.title && (
				<Heading
					className={styles["offer-card-gallery__title"]}
					styledAs="h1"
					tag="h2"
				>
					{props.title}
				</Heading>
			)}

			<div className={`grid ${styles["offer-card-gallery__grid"]}`}>
				{props.cardsContent?.map((card, index) => (
					<div
						key={`${card.title}-${index}`}
						className="col-xs-12 col-md-6"
					>
						<OfferCardBlock {...card} />
					</div>
				))}
			</div>
		</Container>
	);
}
